import { render } from "./sidebar_brand.html?vue&type=template&id=02a4e1ef&external"
import script from "./sidebar_brand.js?vue&type=script&lang=js&external"
export * from "./sidebar_brand.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__